//mastersheetAPI.js
import axios from 'axios';
import { getCurrentUserId } from '../utils/userUtils';

const API_BASE_URL = 'https://plansync-backend-234288438538.us-central1.run.app/api';  // Updated to use localhost instead of localhost

export const fetchSpreadsheets = async () => {
  try {
    // console.log('Attempting to fetch spreadsheets...');
    const response = await axios.get(`${API_BASE_URL}/spreadsheets`);
    // console.log('Spreadsheets fetched successfully:', response.data);
    return response.data.spreadsheets;
  } catch (error) {
    console.error('Error fetching spreadsheets:', error);
    if (error.response) {
      console.error('Error response:', error.response.data);
      console.error('Error status:', error.response.status);
    } else if (error.request) {
      console.error('Error request:', error.request);
    }
    throw error;
  }
};

export const fetchUserYears = async () => {
  const userid = getCurrentUserId();
  if (!userid) {
    throw new Error('User ID not found');
  }
  
  try {
    const response = await fetch(`https://plansync-backend-234288438538.us-central1.run.app/api/user_years/${userid}`);
    if (!response.ok) {
      throw new Error('Failed to fetch user years');
    }
    const data = await response.json();
    return data.years;
  } catch (error) {
    console.error('Error fetching user years:', error);
    throw error;
  }
};

export const fetchSpreadsheetData = async (spreadsheetName, year) => {
  const userid = getCurrentUserId();
  if (!userid) {
    throw new Error('User ID not found');
  }

  try {
    const response = await fetch(`https://plansync-backend-234288438538.us-central1.run.app/api/spreadsheet/${userid}/${spreadsheetName}/${year}`);
    if (!response.ok) {
      throw new Error('Failed to fetch spreadsheet data');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching spreadsheet data:', error);
    throw error;
  }
};

export const updateSpreadsheetData = async (username, sheetName, year, data) => {
  try {
    // console.log(`Updating data for ${sheetName}, ${username}, ${year}`);
    // console.log("Data being sent:", JSON.stringify(data, null, 2));
    const response = await axios.post(
      `${API_BASE_URL}/update_spreadsheet/${username}/${sheetName}/${year}`,
      data,
      { headers: { 'Content-Type': 'application/json' } } // Ensure data is sent as JSON
    );
    // console.log("Update response:", response.data);
    return response.data;
  } catch (error) {
    console.error(`Error updating data for ${sheetName}:`, error);
    if (error.response) {
      console.error('Error response:', error.response.data);
      console.error('Error status:', error.response.status);
      // Log the detailed error information
      if (error.response.data.detail) {
        console.error('Validation errors:');
        error.response.data.detail.forEach(err => {
          console.error(` - ${err.loc.join(' -> ')}: ${err.msg}`);
        });
      }
    } else if (error.request) {
      console.error('Error request:', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    throw error;
  }
};

export const updateSpreadsheetCell = async (spreadsheetName, year, cellData) => {
  const userid = getCurrentUserId();
  if (!userid) {
    throw new Error('User ID not found');
  }

  // console.log(`Updating cell for spreadsheet ${spreadsheetName}, year ${year}, user ${userid}`);
  
  try {
    const response = await fetch(`https://plansync-backend-234288438538.us-central1.run.app/api/update_spreadsheet_cell/${userid}/${spreadsheetName}/${year}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cellData),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to update cell');
    }
    return await response.json();
  } catch (error) {
    console.error('Error updating spreadsheet cell:', error);
    throw error;
  }
};

export const getTableInfo = async (username, sheetName, year) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/table_info/${username}/${sheetName}/${year}`);
    // console.log("Table info response:", response.data);
    return response.data;
  } catch (error) {
    console.error('Error getting table info:', error);
    throw error;
  }
};

export const downloadAllSpreadsheets = async (username, year) => {
  try {
    const response = await fetch(`/api/download-all-spreadsheets?username=${username}&year=${year}`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `All_Spreadsheets_${year}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading spreadsheets:', error);
    throw error;
  }
};

export const deleteSpreadsheetRow = async (userid, spreadsheetName, year, unid) => {
  // console.log("DELETE SPREADSHEET ROW HAS BEEN CALLED")
  // console.log("USERID: ", userid)
  // console.log("SPREDSHEET NAME: ", spreadsheetName)
  // console.log("YEAR: ", year)
  // console.log("Type of year:", typeof year);
  // console.log("UNID: ", unid)
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/delete_spreadsheet_row/${userid}/${spreadsheetName}/${year}/${unid}`,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    if (response.data.error) {
      throw new Error(response.data.error);
    }
    
    return response.data;
  } catch (error) {
    console.error('Error deleting spreadsheet row:', error);
    if (error.response) {
      console.error('Error response:', error.response.data);
      console.error('Error status:', error.response.status);
    }
    throw error;
  }
};



export const getSpreadsheetNames = async () => {
  const response = await axios.get(`${API_BASE_URL}/spreadsheets`);
  return response.data;
};



export const getPresetRequirements = async (userId) => {
  try {
    console.log("GETTING PRESET REQUIREMENTS")
    const response = await fetch(`${API_BASE_URL}/preset-requirements-checklist`, {
      headers: {
        'user-id': userId,
        'Content-Type': 'application/json'
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to fetch preset requirements');
    }

    const data = await response.json();
    // console.log('Preset requirements data:', data);
    return data;
  } catch (error) {
    console.error('Error fetching preset requirements:', error);
    throw error;
  }
};

export const updateIncludeChecklist = async (userId, updates) => {
  try {
    const response = await fetch(`${API_BASE_URL}/update-include-checklist/${userId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to update checklist status');
    }

    const data = await response.json();
    // console.log('Update response:', data);
    return data;
  } catch (error) {
    console.error('Error updating checklist status:', error);
    throw error;
  }
};

export const updateAllIncludeChecklist = async (userId, includeChecklist) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/update-all-include-checklist/${userId}?include_checklist=${includeChecklist}`, 
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to update all checklist statuses');
    }

    const data = await response.json();
    // console.log('Update all response:', data);
    return data;
  } catch (error) {
    console.error('Error updating all checklist statuses:', error);
    throw error;
  }
};

export const rewriteTouchpoints = async (year, options) => {
  const userid = getCurrentUserId();
  if (!userid) {
    throw new Error('User ID not found');
  }

  try {
    const response = await fetch(`${API_BASE_URL}/touchpoints/${year}/rewrite`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'user-id': userid
      },
      body: JSON.stringify({
        unids: options.unids || null,
        rewrite_all: options.rewrite_all || false,
        rewrite_empty: options.rewrite_empty || false
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to rewrite touchpoints');
    }

    return await response.json();
  } catch (error) {
    console.error('Error rewriting touchpoints:', error);
    throw error;
  }
};

export const rewriteRequirements = async (year, options) => {
  const userid = getCurrentUserId();
  if (!userid) {
    throw new Error('User ID not found');
  }

  try {
    const response = await fetch(`${API_BASE_URL}/requirements/${year}/rewrite`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'user-id': userid
      },
      body: JSON.stringify({
        unids: options.unids || null,
        rewrite_all: options.rewrite_all || false,
        rewrite_empty: options.rewrite_empty || false
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to rewrite requirements');
    }

    return await response.json();
  } catch (error) {
    console.error('Error rewriting requirements:', error);
    throw error;
  }
};

export const fetchClients = async (userId, year) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/spreadsheet/${userId}/Client List/${year}`
    );
    if (!response.ok) {
      throw new Error('Failed to fetch clients');
    }
    const data = await response.json();
    return data.data; // Assuming clients are in data.data
  } catch (error) {
    console.error('Error fetching clients:', error);
    throw error;
  }
};

export const updateRequirementCompletion = async (userId, year, data) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/update_requirement_completion/${userId}/${year}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw new Error('Failed to update completion statuses');
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error updating completion statuses:', error);
    throw error;
  }
};
